import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-basket-audit-hub',
  templateUrl: './basket-audit-hub.component.html',
  styleUrls: ['./basket-audit-hub.component.scss']
})
export class BasketAuditHubComponent {
  @Input() storeId: string = '';

  activeSection: 'audit-trail' | 'scan-insights' = 'audit-trail';

  setSection(section: 'audit-trail' | 'scan-insights'): void {
    this.activeSection = section;
  }
}
